<nz-layout class="layout">
  <nz-layout>
    <div class="header-content">
      <img class="banner-header" src="./assets/images/banner/banner-header.png">
      <img class="banner-header-logo" src="./assets/images/banner/logo.png">
    </div>
    <nz-content>
      <div class="container-header header-font-size">
        {{'S0000.S0001' | translate}}
      </div>
      <div class="container-register">
        <div nz-row>
          <div nz-col nzXs="17" nzLg="18" nzXl="19"></div>
          <div nz-col nzXs="7" nzLg="6" nzXl="5">
            <div class="text-right">
              <button class="btn-download body-font-size" (click)="downloadDoc()">
                <i nz-icon nzType="download" nzTheme="outline"></i>
                {{'S0000.S0022' | translate}}
              </button>
            </div>
          </div>
        </div>
        <form nz-form [formGroup]="form">
          <div nz-row class="pt-3">
            <div nz-col nzXs="24" nzLg="24" nzXl="24">
              <div class="title-register sub-header-font-size">{{'S0000.S0003' | translate}}</div>
            </div>
          </div>
          <div nz-row>
            <div nz-col nzXs="5" nzLg="3" nzXl="0"></div>
            <nz-form-item nz-col nzXs="6" nzLg="6" nzXl="6">
              <div class="label-input body-font-size"> {{'S0000.S0004' | translate}} :</div>
            </nz-form-item>
            <nz-form-item nz-col nzXs="8" nzLg="8" nzXl="8">
              <nz-form-control [nzErrorTip]="iDTpl">
                <input placeholder="x-xxxx-xxxxx-xx-x" type="text" nz-input class="input-radius body-font-size"
                  formControlName="idCard" maxlength="13" (keypress)="numberOnly($event)" (keyup)="setIdCard()" />
                <ng-template #iDTpl let-control>
                  <ng-container *ngIf="control.hasError('required')"></ng-container>
                  <ng-container *ngIf="control.hasError('minlength')">
                    <div class="body-font-size">
                      {{'A0000.A0031' | translate}}
                    </div>
                  </ng-container>
                  <ng-container *ngIf="control.hasError('idCardIsSame')">
                    <div class="body-font-size">
                      {{'S0000.S0005' | translate}}
                    </div>
                  </ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-row>
            <div nz-col nzXs="5" nzLg="3" nzXl="0"></div>
            <nz-form-item nz-col nzXs="6" nzLg="6" nzXl="6">
              <div class="label-input body-font-size"> {{'S0000.S0006' | translate}} :</div>
            </nz-form-item>
            <nz-form-item nz-col nzXs="8" nzLg="8" nzXl="8">
              <nz-form-control [nzErrorTip]="titleNameTpl">
                <input type="text" nz-input class="input-radius body-font-size" formControlName="titleName" />
                <ng-template #titleNameTpl let-control>
                  <ng-container *ngIf="control.hasError('required')"></ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-row>
            <div nz-col nzXs="5" nzLg="3" nzXl="0"></div>
            <nz-form-item nz-col nzXs="6" nzLg="6" nzXl="6">
              <div class="label-input body-font-size"> {{'S0000.S0007' | translate}} :</div>
            </nz-form-item>
            <nz-form-item nz-col nzXs="8" nzLg="8" nzXl="8">
              <nz-form-control [nzErrorTip]="firstNameTpl">
                <input type="text" nz-input class="input-radius body-font-size" formControlName="firstName"
                  maxlength="30" />
                <ng-template #firstNameTpl let-control>
                  <ng-container *ngIf="control.hasError('required')"></ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-row>
            <div nz-col nzXs="5" nzLg="3" nzXl="0"></div>
            <nz-form-item nz-col nzXs="6" nzLg="6" nzXl="6">
              <div class="label-input body-font-size"> {{'S0000.S0008' | translate}} :</div>
            </nz-form-item>
            <nz-form-item nz-col nzXs="8" nzLg="8" nzXl="8">
              <nz-form-control [nzErrorTip]="lastNameTpl">
                <input type="text" nz-input class="input-radius body-font-size" formControlName="lastName"
                  maxlength="30" />
                <ng-template #lastNameTpl let-control>
                  <ng-container *ngIf="control.hasError('required')"></ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-row class="pt-3">
            <div nz-col nzXs="24" nzLg="24" nzXl="24">
              <div class="title-register sub-header-font-size">{{'S0000.S0009' | translate}}</div>
            </div>
          </div>
          <div nz-row>
            <div nz-col nzXs="5" nzLg="3" nzXl="0"></div>
            <nz-form-item nz-col nzXs="6" nzLg="6" nzXl="6">
              <div class="label-input body-font-size"> {{'S0000.S0010' | translate}} :</div>
            </nz-form-item>
            <nz-form-item nz-col nzXs="8" nzLg="8" nzXl="8">
              <nz-form-control [nzErrorTip]="usernameTpl">
                <input type="text" nz-input class="input-radius body-font-size" formControlName="username"
                  maxlength="30" (keyup)="setUsername()" />
                <ng-template #usernameTpl let-control>
                  <ng-container *ngIf="control.hasError('required')"></ng-container>
                  <ng-container *ngIf="control.hasError('minlength')">โปรดระบุอย่างน้อย 5 ตัวอักษร</ng-container>
                  <ng-container *ngIf="control.hasError('usernameIsSame')">{{'S0000.S0011' | translate}}</ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-row>
            <div nz-col nzXs="5" nzLg="3" nzXl="0"></div>
            <nz-form-item nz-col nzXs="6" nzLg="6" nzXl="6">
              <div class="label-input body-font-size">{{'S0000.S0012' | translate}} :</div>
            </nz-form-item>
            <nz-form-item nz-col nzXs="8" nzLg="8" nzXl="8">
              <nz-form-control [nzErrorTip]="">
                <nz-select nzShowSearch nzAllowClear class="select-custom body-font-size"
                  formControlName="hospitalCode">
                  <nz-option *ngFor="let item of hospList" [nzLabel]="item.label" [nzValue]="item.hospCode"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-row>
            <div nz-col nzXs="5" nzLg="3" nzXl="0"></div>
            <nz-form-item nz-col nzXs="6" nzLg="6" nzXl="6">
              <div class="label-input body-font-size">{{'S0000.S0013' | translate}} :</div>
            </nz-form-item>
            <div nz-col nzXs="8" nzLg="8" nzXl="8">
              <div style="text-align: left;" (click)="uploadDoc()">
                <textarea class="input-radius textarea-custom body-font-size" nz-input nzAutosize readonly
                  formControlName="fileName">
                </textarea>
              </div>
            </div>
            <div nz-col nzXs="2" nzLg="2" nzXl="1">
              <button class="upload-button search-button body-font-size" nz-button (click)="uploadDoc()"
                nzType="primary">
                <i class="upload-icon" nz-icon nzType="folder-open" nzTheme="fill"></i>
              </button>
            </div>
          </div>
          <div nz-row>
            <div nz-col nzXs="5" nzLg="3" nzXl="0"></div>
            <nz-form-item nz-col nzXs="6" nzLg="6" nzXl="6">
              <div class="label-input body-font-size"> {{'S0000.S0014' | translate}} :</div>
            </nz-form-item>
            <nz-form-item nz-col nzXs="8" nzLg="8" nzXl="8">
              <nz-form-control [nzErrorTip]="">
                <input placeholder="xxx@email.com" type="email" nz-input class="input-radius body-font-size"
                  formControlName="email" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-row>
            <div nz-col nzXs="5" nzLg="3" nzXl="0"></div>
            <nz-form-item nz-col nzXs="6" nzLg="6" nzXl="6">
            </nz-form-item>
            <nz-form-item nz-col nz-col nzXs="8" nzLg="8" nzXl="8">
              <nz-form-control [nzErrorTip]="">
                <label nz-checkbox formControlName="confirm" (ngModelChange)="popupAgreement($event)">
                  <span class="confirm-text body-font-size">{{'S0000.S0015' | translate}}</span>
                </label>
                <!-- <input type="checkbox" [(ngModel)]="isOkAgreement" formControlName="confirm" (change)="popupAgreement()" /> -->
                <!-- <span (click)="popupAgreement()" class="confirm-text body-font-size" >
                  {{'S0000.S0015' | translate}}
                </span> -->
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-row class="mt-5">
            <nz-form-item nz-col nzXs="8" nzLg="8" nzXl="8">
              <div class="btn-wrapper" style="text-align: left;">
                <div class="btn-styles btn-previous text-center body-font-size" (click)="previousPage()">
                  <div class="txt">
                    <button type="button">
                      < {{'S0000.S0016' | translate}} </button>
                  </div>
                </div>
              </div>
            </nz-form-item>
            <nz-form-item nz-col nzXs="7" nzLg="5" nzXl="5">
              <nz-form-control>
                <div class="btn-wrapper" style="text-align: left;">
                  <div [ngClass]="this.form.get('confirm').value === false ? 'btn-disable' : 'btn-blue'"
                    class="btn-styles text-center body-font-size" (click)="register()">
                    <div class="txt">
                      <button type="button">{{'S0000.S0017' | translate}}</button>
                    </div>
                  </div>
                </div>
              </nz-form-control>
            </nz-form-item>
            <nz-form-item nz-col nzXs="8" nzLg="5" nzXl="5">
              <nz-form-control>
                <div class="btn-wrapper" style="text-align: left;">
                  <div class="btn-styles btn-gray text-center body-font-size" (click)="onReset()">
                    <div class="txt">
                      <button type="button">{{'S0000.S0018' | translate}}</button>
                    </div>
                  </div>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </form>
      </div>
    </nz-content>
    <nz-footer>Copyright © Thai Life Insurance Public Company Limited. All Rights Reserved</nz-footer>
  </nz-layout>
</nz-layout>
<app-upload-user-modal [isVisible]='openModal' [fileList]='fileList' (closeModal)="closeModal($event)">
</app-upload-user-modal>
<app-warning-modal [isWarning]='isWarning' [textWarnnig]='textWarnnig' [titelWarnnig]='titelWarnnig'
  (close)="closeWarning()">
</app-warning-modal>